import { render } from "./SendMoney.vue?vue&type=template&id=9120fe12&scoped=true"
import script from "./SendMoney.vue?vue&type=script&lang=js"
export * from "./SendMoney.vue?vue&type=script&lang=js"

import "./SendMoney.vue?vue&type=style&index=0&id=9120fe12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-9120fe12"

export default script